import React, { useEffect, useState } from "react";
import ReactTable from "react-table";
import { Link } from "react-router";
import { capitalizeFirstLetter } from "/src/util/utilities";
import Button from "../Button"

const HURejectedEnrollments = ({ csEnrollments, fetchCSEnrollments, selectedView }) => {
  const [page, setPage] = useState(1);
  useEffect(() => {
    if (selectedView === "HU Rejects") {
      setPage(1);
      fetchCSEnrollments("hu_reject", 1);
    }
  }, [selectedView, fetchCSEnrollments]);

  const columns = [
    {
      id: 'member_id',
      Header: 'Member ID',
      accessor: (row) => {
        if (row.member_id) {
          return <Link to={`/members/${row.member_id}/details`}>{row.member_id}</Link>
        }
        return row.member_id
      },
    },
    {
      Header: 'Name',
      accessor: 'name',
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>)
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>)
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>)
    },
    {
      Header: 'Utility Name',
      accessor: 'utility_name',
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>)
    },
    {
      Header: 'State Code',
      accessor: 'state',
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>)
    },
    {
      Header: 'Meter Status',
      accessor: 'meter_status',
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{capitalizeFirstLetter(value)}</div>)
    },
    {
      Header: 'Status Reason',
      accessor: 'status_reason',
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>)
    },
    {
      Header: 'Signing Status',
      accessor: 'document_signing_status',
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>)
    },
    {
      Header: 'Enrollment Complete Date',
      accessor: 'enrollment_completion_date',
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value ? value.replace("T", " ").slice(0, 10) : ""}</div>)
    },
  ];

  const handlePagination = () => {
    if (csEnrollments?.has_next) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchCSEnrollments("hu_reject", nextPage);
    }
  };

  return (
    <div>
      <ReactTable
        data={csEnrollments?.list || []}
        columns={columns}
        className="-striped -highlight"
        defaultPageSize={10}
        defaultSorted={[
          {
            id: "enrollment_completion_date",
            desc: true,
          }
        ]}
        filterable
      />
      {csEnrollments?.has_next && (
        <Button
          variant="contained"
          color="primary"
          style={{
            marginTop: "20px",
            width: "150px",
            alignSelf: "flex-end",
          }}
          onClick={handlePagination}
        >
          Load More
        </Button>
      )}
      {(csEnrollments?.list || []).length > 0 && page * (csEnrollments?.limit || 100) < csEnrollments?.total ? (
        <div style={{ float: "right", marginTop: "10px" }}>
          Downloaded {page * (csEnrollments?.limit || 100)} of {csEnrollments?.total} CS enrollments
        </div>
      ) : (
        (csEnrollments?.list || []).length > 0 && (
          <div style={{ float: "right", marginTop: "10px" }}>
            Downloaded all {csEnrollments?.total} CS enrollments
          </div>
        )
      )}
    </div>
  );
};

export default HURejectedEnrollments;